/**
 * 封装头部导航组件
 */

import {
    QuestionOutlined,
    LogoutOutlined,
    SettingOutlined,
} from '@ant-design/icons';
import {
    Layout,
    Row,
    Col,
    Dropdown,
    Avatar,
    Button,
    message,
    theme,
    ConfigProvider,
} from 'antd';
import cookie from 'react-cookies';
import CNF from '../incs/Config';
import { DeleteCookies } from '../incs/FunHelper';

import XNavService from './XNavService';

const { Header } = Layout;

const onClick = (e) => {
    if (e.key === '1') {
        window.location.href = CNF.userUrl;
    }
    if (e.key === '2') {
        message.info('正在努力开发中......');
    }
    if (e.key === '3') {
        // 退出登录
        DeleteCookies()
    }
}

const XHeader = (props) => {
    const {
        token: { colorPrimary },
    } = theme.useToken();

    const items = [
        {
            key: '1',
            label: <Button icon={<SettingOutlined />} color='primary' variant='link'>设置</Button>,
        },
        {
            key: '2',
            label: <Button icon={<QuestionOutlined />} color='primary' variant='link'>帮助</Button>,
        }, {
            key: '3',
            label: <Button icon={<LogoutOutlined />} color='primary' variant='link'>退出</Button>,
        }
    ]
    return (
        <ConfigProvider
            theme={{
                components: {
                    Dropdown: {
                        paddingBlock: 0,
                    },
                    Button: {
                        paddingInline: 0,
                    }
                },
            }}
        >
            <Header style={{
                padding: 0,
                height: CNF.menuHeight,
                lineHeight: CNF.menuLineHeight,
                position: 'fixed',
                width: '100%',
                top: 20,
                zIndex: 9,
                boxShadow: '0 3px 3px 1px' + CNF.bassicColor,
            }}>
                <Row justify='end'>
                    {
                        props.navLists.length > 0 && props.navLists.map((item) => {
                            return <Col key={item.name} span={1}>
                                <Button color='primary' variant='link' href={item.url} rel='noopener noreferrer' title={item.name}>{item.name}</Button>
                            </Col>
                        })
                    }
                    <Col span={1}></Col>
                    <Col span={2}>
                        <XNavService
                            setThemeColor={props.setThemeColor}
                            isCompact={props.isCompact}
                            setIsCompact={props.setIsCompact}
                        />
                    </Col>
                    <Col span={2}><Button color='primary' variant='link' onClick={(e) => {
                        e.preventDefault();
                    }}>简体中文</Button></Col>
                    <Col span={1} style={{ display: 'flex', alignItems: 'center', }}>
                        <Dropdown menu={{ items, onClick }}>
                            <Button type='link'>
                                {
                                    cookie.load(CNF.cookies.keyAvatarUrl) ? (
                                        <Avatar
                                            size='middle'
                                            src={cookie.load(CNF.cookies.keyAvatarUrl) ? CNF.ossApi + cookie.load(CNF.cookies.keyAvatarUrl) : ''}
                                        />
                                    ) : (
                                        <Avatar
                                            style={{
                                                verticalAlign: 'middle',
                                                backgroundColor: colorPrimary,
                                            }}
                                            size='middle'
                                        >
                                            {cookie.load(CNF.cookies.keyId) ? cookie.load(CNF.cookies.keyId).substr(0, 1).toUpperCase() : 'U'}
                                        </Avatar>
                                    )
                                }
                            </Button>
                        </Dropdown>
                    </Col>
                </Row>
            </Header >
        </ConfigProvider>
    )
}

export default XHeader